import { render } from "./Cadastrar.vue?vue&type=template&id=00a0a8cf&scoped=true"
import script from "./Cadastrar.vue?vue&type=script&lang=js"
export * from "./Cadastrar.vue?vue&type=script&lang=js"

import "./Cadastrar.vue?vue&type=style&index=0&id=00a0a8cf&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a0a8cf"]])

export default __exports__